import { useOnChangeRef } from '@/features/form/hooks/useOnChangeRef'
import { OnChange } from '@/features/form/types'
import { useCallback } from 'react'

export const useUpdateProductVariant = (onChange: OnChange): ((id: string) => void) => {
    const onChangeRef = useOnChangeRef(onChange)

    return useCallback((id: string) => onChangeRef.current(id), [onChangeRef])
}
